/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import { useSelector } from 'react-redux';

import { Button, LinkBlock } from '../../../../components/common';
import { makeSelectTranslationCommon } from '../../../internationalization/intSelectors';
import Modal from '../../../modal/components/Modal';

interface ITableExportModal {
    handleClose: () => void;
    handleSubmit: () => void;
}

const TableExportModal = ({ handleClose, handleSubmit }: ITableExportModal) => {

    const { export: tExport } = useSelector(makeSelectTranslationCommon());

    return (
        <Modal dataName="export-message-popup" width="580px">
            <Modal.Title>{tExport.popupTitle}</Modal.Title>
            <Modal.Text>{tExport.popupText}</Modal.Text>
            <Modal.Control>
                <Button
                    className="export-message__apply-btn"
                    kind="mediumNormal"
                    onClick={handleSubmit}
                >
                    {tExport.export}
                </Button>
                <LinkBlock
                    className="export-message__cancel-btn"
                    onClick={handleClose}
                >
                    {tExport.cancel}
                </LinkBlock>
            </Modal.Control>
        </Modal>
    );
};

export default TableExportModal;
